// Mock data for Top of the Rock Glamping

export const accommodations = [
  {
    id: 1,
    type: "shepherd-hut",
    name: "Luxury Shepherd's Hut",
    description: "Cosy and romantic ensuite shepherd's huts with floor-to-ceiling windows, king-size beds, and heating. Each hut includes its own private field perfect for exercising your four-legged friends. Enjoy excellent mobile and 4G coverage throughout your stay.",
    features: [
      "Floor-to-ceiling windows",
      "King-size bed",
      "Ensuite lavatory & shower room",
      "Full heating",
      "Private field for dogs",
      "Dog-friendly (no extra charge)",
      "Microwave, fridge, toaster & kettle",
      "Private off-road parking",
      "Good mobile & 4G coverage"
    ],
    facilities: [
      "Disposable BBQs available on site",
      "Firewood for fire pits",
      "Fresh eggs from honesty freezer",
      "Farm sausages, burgers & bacon",
      "Seasonal salad & vegetables"
    ],
    price: 100,
    singleNightPrice: 125,
    capacity: 2,
    quantity: 3,
    image: "https://customer-assets.emergentagent.com/job_cosy-huts-camp/artifacts/0j37k1j2_1000030866.png"
  },
  {
    id: 2,
    type: "camping",
    name: "Family-Friendly Camping Pitch",
    description: "Exclusive private camping pitches perfect for families who want to reconnect with nature. Each pitch has its own hot shower and eco toilet facilities, with plenty of space for the kids to play and explore safely.",
    features: [
      "Private pitch",
      "Hot shower",
      "Eco toilet",
      "Family-friendly",
      "Dog-friendly",
      "Safe outdoor space",
      "Mountain views",
      "Up to 4 people"
    ],
    price: 30,
    capacity: 4,
    quantity: 2,
    image: "https://customer-assets.emergentagent.com/job_cosy-huts-camp/artifacts/lwrr1wy1_1000030883.png"
  }
];

export const activities = [
  {
    id: 1,
    name: "Mountain Walking",
    description: "Explore the breathtaking Welsh mountains right from our doorstep. Multiple trails suitable for all abilities.",
    icon: "mountain",
    image: "https://customer-assets.emergentagent.com/job_cosy-huts-camp/artifacts/5tj4otnw_1000030873.png"
  },
  {
    id: 2,
    name: "Mountain Biking",
    description: "Caersws Bike Park - a world-class venue just 4.5 miles away. Challenging trails for all skill levels.",
    icon: "bike",
    distance: "4.5 miles"
  },
  {
    id: 3,
    name: "Fishing",
    description: "Llyn Clywedog Trout Fishery - one of the UK's best fishing destinations. Perfect for a peaceful day by the water.",
    icon: "fish",
    image: "https://customer-assets.emergentagent.com/job_cosy-huts-camp/artifacts/6xhwj1ta_1000030877.png"
  },
  {
    id: 4,
    name: "Farm Experience",
    description: "Experience life on our working farm. We produce holistically raised meat available for purchase.",
    icon: "leaf"
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_cosy-huts-camp/artifacts/0j37k1j2_1000030866.png",
    title: "Shepherd's Hut Exterior",
    category: "accommodation"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_cosy-huts-camp/artifacts/epxgnkq9_1000030867.png",
    title: "Cozy Interior",
    category: "accommodation"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_cosy-huts-camp/artifacts/5tj4otnw_1000030873.png",
    title: "Countryside Views",
    category: "landscape"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_cosy-huts-camp/artifacts/7i6dfn7w_1000030878.png",
    title: "Stunning Sunset Views",
    category: "landscape"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_cosy-huts-camp/artifacts/6xhwj1ta_1000030877.png",
    title: "Llyn Clywedog Lake",
    category: "activities"
  },
  {
    id: 6,
    url: "https://customer-assets.emergentagent.com/job_cosy-huts-camp/artifacts/044eybvi_1000030885.png",
    title: "Welcome to Top of the Rock",
    category: "accommodation"
  },
  {
    id: 7,
    url: "https://customer-assets.emergentagent.com/job_cosy-huts-camp/artifacts/lwrr1wy1_1000030883.png",
    title: "Camping with Mountain Views",
    category: "accommodation"
  },
  {
    id: 8,
    url: "https://customer-assets.emergentagent.com/job_cosy-huts-camp/artifacts/eonr4n0t_1000030874.png",
    title: "Private Field Views",
    category: "landscape"
  },
  {
    id: 9,
    url: "https://customer-assets.emergentagent.com/job_cosy-huts-camp/artifacts/8kvy6xy7_1000030871.png",
    title: "Scenic Welsh Countryside",
    category: "landscape"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah & James",
    location: "Manchester",
    rating: 5,
    text: "Absolutely magical stay! The shepherd's hut was incredibly cosy with stunning views. Our dog loved having his own field to run around in.",
    date: "2024-03"
  },
  {
    id: 2,
    name: "Mike Thompson",
    location: "Birmingham",
    rating: 5,
    text: "Perfect base for mountain biking at Caersws. The facilities were excellent and the hosts were so welcoming. Can't wait to return!",
    date: "2024-02"
  },
  {
    id: 3,
    name: "Emily & Tom",
    location: "London",
    rating: 5,
    text: "The most romantic getaway! Floor-to-ceiling windows with mountain views from bed. Pure luxury in the heart of nature.",
    date: "2024-01"
  }
];

export const contactInfo = {
  farmName: "Pen Y Graig Farm",
  businessName: "Top of the Rock Glamping",
  email: "lmforestryltd@gmail.com",
  phone: "07796 316187",
  facebook: "https://www.facebook.com/TopoftheRockGlamping",
  location: {
    address: "Pen Y Graig, Trefeglwys, Caersws, SY17 5RG",
    fullAddress: "Pen Y Graig\nTrefeglwys\nCaersws\nSY17 5RG",
    coordinates: { lat: 52.50585, lng: -3.53102 }
  }
};
